import { useSearchParam } from "./useSearchParam";

export const useSelectedWorkspaceParam = (): [string, (value: string) => void] => {
  const [value, setValue] = useSearchParam("workspace");
  return [value ?? "", (next: string) => setValue(next || null)];
};
